<template>
	<div class="scroll-notice" :style="styleBg">
		<div class="notice-content3" v-if="datas.contentType == '3'" :style="noticeStyle" @click="goLink(datas.link)">
			<img class="scroll-notice-icon" :src="datas.logo" v-if="datas.logo">
			<div class="scroll-text">
				<scrolling-text :text="datas.descript"></scrolling-text>
			</div>

		</div>
		<div class="scroll-notice-content" :style="noticeStyle" v-else-if="datas.rollStyle == 'row'&&datas.items.length>0">
			<div class="notice-content3" :style="noticeStyle" ref="scrollingTextContainer">
				<img class="scroll-notice-icon" :src="datas.logo" v-if="datas.logo">
				<img class="scroll-notice-icon" src="https://xcx.ihotel.cn/mall/images/notice.png" v-else>
				<div class="scroll-tit-box">
					<div class="scroll-tit" ref="scrollingText" :style="style">
						<div class="tit" v-for="(item, index) in datas.items" :key="index" @click="toLink(item)">{{ item.tit }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="scroll-notice-content" :style="noticeStyle" v-else-if="datas.items.length>0">
			<ul class="scroll-notice-list" :style="style" ref="list">
				<li class="notice-content3" v-for="(item, index) in datas.items" :key="index" @click="toLink(item)">
					<img class="scroll-notice-icon" :src="datas.logo" v-if="datas.logo">
					<img class="scroll-notice-icon" src="https://xcx.ihotel.cn/mall/images/notice.png" v-else>
					<span class="text">{{ item.tit }}</span>
				</li>
			</ul>

		</div>
	</div>
</template>

<script>
	// 滚动消息
	import scrollingText from "@/components/polymerization/scrollingText.vue";
	import api from '@/utils/api'
	import { getStorage } from "@/utils/wxuser";
	var config = {}
	export default {
		name: "ScrollNotice",
		props: {
			datas: Object
		},
		data() {
			return {
				style: "",
				timer: null
			};
		},
		methods: {
			checkTextWidth() {

				this.$nextTick(() => {
					const containerWidth = this.$refs.scrollingTextContainer.offsetWidth;
					const textWidth = this.$refs.scrollingText.offsetWidth;

					if (textWidth > containerWidth) {
						const duration = textWidth / 50;
						this.style = `animation-duration:${duration}s`;
					}

				})

			},
			toLink(item) {
				if (item.link != '') {
					window.location.href = item.link
				}
			},
			setScroll() {
				let i = 1;
				this.timer = setInterval(() => {
					this.style = "transform:translateY(" + 34 * -i + "px)"
					i++;
					if (i >= this.datas.items.length) {
						i = 0
					}
				}, 5000);
			}
		},
		components: {
			scrollingText
		},
		computed: {
			styleBg() {
        return `background:${this.datas.wrapColor};`;
      },
			noticeStyle() {
        var style = "";
        if (this.datas.contentType == "3"||this.datas.contentType == "1") {
          style += `height: 34px;border-radius: 17px;`;
          if (this.datas.color) {
            style += `color: ${this.datas.color};`;
          }
          if (this.datas.bgColor) {
            style += `background: ${this.datas.bgColor};`;
          }
        }
        return style;
      },
		},
		mounted() {
			config = getStorage('config')
			if (this.datas.rollStyle == 'row') {
				this.checkTextWidth()
			} else {
				if (this.datas.items && this.datas.items.length > 1 && this.datas.contentType != 3) {
					this.setScroll();
				}
			}
			// if (this.datas.openServe) {
			// 	var opt = {
			// 		"config": {
			// 			"interfaceType": "GET",
			// 			"interfaceModule": "ZHZ_URL",
			// 			"interfaceMethod": "open/gcshop/getMsgList",
			// 			"interfaceFrom": "GC",
			// 			"hotelGroupCode": config.hotelGroupCode
			// 		},
			// 		"query": {
			// 			"appId": config.appid,
			// 			"token": "11111"
			// 		}
			// 	}


			// 	api.interfaceTransfer(opt).then((res) => {
			// 		if (res.result == 1) {
						
			// 		}
			// 	});
			// }


		},
		beforeDestroy() {
			clearInterval(this.timer);
		}
	};
</script>
<style lang="less">
	.scroll-notice {
		padding: .266667rem 0.4rem 0;


		.scroll-notice-content {
			height: 34px;
			overflow: hidden;
			background: #eef2f6;

			border-radius: 17px;

		}

		.notice-content3 {
			display: flex;
			align-items: center;
			height: 34px;
			// background: #eef2f6;
			border-radius: 17px;
			padding: 0 12px;

			.scroll-notice-icon {
				margin-right: 10px;
				width: 14px;
				height: 14px;
			}

			.scroll-text {
				flex: 1;
				overflow: hidden;

			}

			.scroll-tit {
				display: flex;
				white-space: nowrap;
				
			}

			.text {
				flex: 1;
				display: inline-block;
				overflow: hidden;
				vertical-align: top;
				white-space: normal;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				overflow: hidden;
				font-size: 12px;
			}
		}

		.scroll-notice-list {
			-webkit-transition: -webkit-transform 0.5s ease, transform 0.5s ease;
			transition: -webkit-transform 0.5s ease, transform 0.5s ease;

			.scroll-notice-list-item {
				height: 34px;
				display: flex;
				align-items: center;

				white-space: nowrap;

				.scroll-notice-icon {
					width: 18px;
					height: 18px;
					margin-right: 5px;
					vertical-align: top;
				}

				.text {
					display: inline-block;
					overflow: hidden;
					flex: 1;
					font-size: 13px;
					line-height: 34px;
					vertical-align: top;
					color: #333;
					white-space: normal;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}
			}
		}

		.scroll-tit-box {
			flex: 1;
			overflow: hidden;
		}

		.scroll-tit {
			white-space: nowrap;
			font-size: 14px;

			width: fit-content;
			animation: scrollText linear infinite;
			.tit{
           margin-right: 100px;
					 &:last-child{
						margin-right: 0;
					 }
        }
		}

		@keyframes scrollText {
			to {
				transform: translateX(-100%);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/ScrollNotice.vue